import React from "react";

export const Footer = () => {
  return (
    <div className="relative bg-gray-100 pt-12 pb-8 sm:pt-16 md:pt-20 xl:pt-28 sm:pb-16">
      <div className="flex justify-center items-center max-w-screen-xl mx-auto">
        <div className="text-sm font-medium">
          Copyright &#169; {new Date().getFullYear()} Canopus GraphQL
        </div>
        <span
          aria-hidden="true"
          className="hidden sm:block mx-6 h-6 w-px bg-gray-700 bg-opacity-20"
        />
        <div className="ml-6 sm:ml-0">
          <a
            href="https://github.com/canopusgraphql/canopus"
            className="text-gray-700 hover:text-gray-800 transition-colors duration-200"
          >
            <span className="font-semibold">GitHub</span>
          </a>
        </div>
      </div>
    </div>
  );
};
